<div class="al-checkbox" [ngClass]="{'al-checkbox--disabled': disabled}" >
    <input
        type="checkbox"
        [checked]="checked" 
        [disabled]="disabled"
        [id]="checkboxId"
        value=""
        (change)="changeCheck($event)"
        class="al-checkbox__input" />

    <div class="al-checkbox__box">
        <svg class="al-checkbox__icon" viewBox="0 0 20 20">
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/>
        </svg>
    </div>
	<label class="al-checkbox__label" [for]="checkboxId">
        {{ label }}
    </label>

</div>
